import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pt pb-4 text-black" }, " We are working hard to improve the CAP experience, and we would love to hear about any suggestions or issues you have. ", -1)
const _hoisted_2 = {
  key: 0,
  class: "pt-4 italic text-gray-700"
}

import { computed, ref } from "vue";
import AModal from "./AModal.vue";
import useUser, { SlackBlock } from "@/services/useUser";
import ATextArea from "@ai-nc/a-components/src/components/input/ATextArea.vue";
import AButton from "@ai-nc/a-components/src/components/button/AButton.vue";
import useToast from "@/services/useToast";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactModal',
  props: {
    context: null,
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update:modelValue", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  context?: SlackBlock[];
  modelValue: boolean;
}

const user = useUser();
const toast = useToast();
const route = useRoute();




const open = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    emits("update:modelValue", value);
  },
});

const message = ref("");

function send() {
  const blocks: SlackBlock[] = [
    {
      type: "context",
      elements: [
        {
          type: "plain_text",
          text: "Message from " + (user.userInfo.name ? user.userInfo.name + " (" + user.id : " (" + user.id) + ")",
        },
        {
          type: "plain_text",
          text: "From page " + window.location.href,
        },
      ],
    },
    { type: "section", text: { type: "plain_text", text: message.value } },
    ...(props.context ? props.context : []),
    {
      type: "actions",
      elements: [
        {
          action_id: "button",
          text: {
            type: "plain_text",
            text: "View Page/Model",
          },
          type: "button",
          url: window.location.href,
        },
      ],
    },
  ];
  user.sendContact(undefined, blocks);

  toast.post({
    severity: "info",
    title: "Message sent",
    message: "Thanks for giving us feedback, we will be in touch soon",
  });

  open.value = false;
  message.value = "";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AModal, {
    modelValue: _unref(open),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(open) ? (open).value = $event : null)),
    heading: "Send us a message",
    class: "w-1/2 max-w-xl"
  }, {
    footer: _withCtx(() => [
      _createVNode(AButton, {
        label: "Send",
        onClick: send,
        disabled: message.value === '',
        size: "small"
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(ATextArea, {
          modelValue: message.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event))
        }, null, 8, ["modelValue"]),
        (_unref(route).path === '/project')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " This will allow us to join your project an view this model. "))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})